export const APPLICATIONS = {
  //columns
  name: "displayName",
  id: "id",
  applicationId: "applicationId",
  status: "status",
  approvedDate: "approvedDate",
  valid_through: "validThrough",
  last_updated: "last_updated",
  actions: "actions",
  claimAmounts: "claimAmounts",
  claimActions: "claimActions",

  // status
  statuses: {
    prepare: "prepare",
    applied: "applied",
    approved: "approved",
    canceled: "canceled",
    expired: "expired",
    appliedToWaitlist: "applied to waitlist",
    rejected: "rejected",
    ineligible: "ineligible",
    notInterested: "not-interested",
    notReturned: "not-returned",
    discarded: "discarded",
    exhausted: "exhausted",
    missingInformation: "missing information",
    temporarilyApproved: "temporarily approved"
  },
  displayStatus: {
    associated: "associated",
    notRelevant: "not-relevant"
  },
  autoFill: {
    keysFormItem: {
      patient: "patient",
      otherPhysician: "otherPhysician",
      singleFinantialNavigationTeam: "singleFinantialNavigationTeam",
      finantialNavigationTeam: "finantialNavigationTeam"
    },
    patientAddress: "Patient address",
    physician: "physician",
    single_physician: "Physician address",
    choose_physician: "choose a physician in the physician information section",
    multiple_physician: "Physician address - multiple associated physicians",
    choosePhysician: "Choose physician from the list",
    fn_team: "FN team",
    multiple_fn_team: "FN team - multiple FN team",
    other_add_details: "Other - add details",
    other: "other",
    coverage: {
      primary: "primary",
      secondary: "secondary",
      rx: "rx"
    },
    FN: {
      multiple: "multiple",
      single: "single"
    }
  },
  pharmacyAccess: {
    default: "Default",
    upsell: "Upsell",
    none: "None"
  }
};

/**
 * Maps application status values to their corresponding translation keys
 * @param {string} status - The status value from APPLICATIONS.statuses
 * @param {function} t - The translation function
 * @param {string} fallbackValue - Fallback value if status is not found (default: "–")
 * @returns {string} - The translated status text
 */
export const getApplicationStatusText = (status, t, fallbackValue = "–") => {
  switch (status) {
    case APPLICATIONS.statuses.prepare:
      return t("patientApplications.prepare");
    case APPLICATIONS.statuses.applied:
      return t("patientApplications.applied");
    case APPLICATIONS.statuses.appliedToWaitlist:
      return t("patientApplications.applied_to_waitlist");
    case APPLICATIONS.statuses.approved:
      return t("patientApplications.approved");
    case APPLICATIONS.statuses.canceled:
      return t("patientApplications.canceled");
    case APPLICATIONS.statuses.expired:
      return t("patientApplications.expired");
    case APPLICATIONS.statuses.exhausted:
      return t("patientApplications.exhausted");
    case APPLICATIONS.statuses.rejected:
      return t("patientApplications.denied");
    case APPLICATIONS.statuses.ineligible:
      return t("patientApplications.ineligible");
    case APPLICATIONS.statuses.notInterested:
      return t("patientApplications.not_interested");
    case APPLICATIONS.statuses.notReturned:
      return t("patientApplications.not_returned");
    case APPLICATIONS.statuses.missingInformation:
      return t("patientApplications.missing_information");
    case APPLICATIONS.statuses.temporarilyApproved:
      return t("patientApplications.temporarily_approved");
    case APPLICATIONS.statuses.discarded:
      return t("patientApplications.discarded");
    default:
      return status || fallbackValue;
  }
};
